<template>
  <div>
    <CardedDisplay>
      <PlainDisplay :show_icon="false">
        <PromotionHeader
          :is_loading="is_loading"
          :promotion="promotion"
          :is_owner_view="is_owner_view"
          :is_in_admin_view="is_in_admin_view"
        ></PromotionHeader>
      </PlainDisplay>
    </CardedDisplay>
    
    <CardedSectionHeader
      icon="mdi-trash-can"
      label="Delete Promotion Concent Form"
      id="owner_delete_promotion_section"
    >
        <v-btn
        @click="$router.go(-1)"
        small
        rounded
        class="mr-4"
        outlined
        color="default"
      >
        <v-icon left>mdi-cancel</v-icon> Cancel Delete
      </v-btn>
    </CardedSectionHeader>
    <DeleteConcentForm
      ref_prop="promotion_delete_form_ref"
      id="promotion_delete_form"
      message="<b>Delete was succesfull</b> <br/> Your promotion removed successfully"
      :is_loading="is_loading || is_owner == false"
      :seed="{promotion:[$route.params.id]}"
      @on-delete-success="on_success"
      @on-hide-loader="$emit('on-hide-loader')"
      @on-show-loader="$emit('on-show-loader')"
    >
    </DeleteConcentForm>
  </div>
</template>


<script>
import ServerClient from "../../../lib/ServerClient";
import CardedDisplay from "./../../../components/CardedDisplay";
import PlainDisplay from "./../../../components/PlainDisplay";
import PromotionHeader from "./../../../components/PromotionHeader";
import CardedSectionHeader from "./../../../components/CardedSectionHeader";
import DeleteConcentForm from "./../../../components/DeleteConcentForm";
import Utils from "../../../lib/Utils";
export default {
  name: "OwnerPromtionsDelete",
  components: {
    CardedDisplay,
    PlainDisplay,
    PromotionHeader,
    CardedSectionHeader,
    DeleteConcentForm
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    is_owner_view: {
      type: Boolean,
      default: true,
    },
    is_in_admin_view: {
      type: Boolean,
      default: false,
    },
    is_in_public_view: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      promotion_id: 0,
      promotion: Utils.get_default_promotion(),
      is_owner: false,
      errors: [],
      message: "",
    };
  },
  methods: {
    on_auto_fill() {
      //no need for this method here
    },
    load_promotion() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotion(
        {
          id: this.promotion_id,
          get_header_only: true,
        },
        (res) => {
          this.$emit("on-hide-loader");
          //   console.log("This one ", res);
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          res.expiry = "";
          if (php_time_now < parseFloat(res.starts_on_timestamp)) {
            res.expiry = "pending";
          } else if (
            php_time_now >= parseFloat(res.starts_on_timestamp) &&
            php_time_now <= parseFloat(res.ends_on_timestamp)
          ) {
            res.expiry = "live";
          } else if (php_time_now > parseFloat(res.ends_on_timestamp)) {
            res.expiry = "expired";
          }

          this.promotion = res;
          if (
            this._user &&
            this._user != null &&
            this.promotion.business &&
            parseInt(this._user.id) == parseInt(this.promotion.business.user_id)
          ) {
            this.is_owner = true;
          }
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading prmomotion details on owners promotion end view",
            errors
          );
        }
      );
    },
    on_success(){
        this.$router.push("/owner/promotions/list");
    }
  },
  mounted() {
    this.promotion_id = parseInt(this.$route.params.id);
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "Remove Promotion",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/owner/promotions",
        },
        {
          text: "List",
          disabled: false,
          href: "/owner/promotions/list",
        },
        {
          text: "View",
          disabled: false,
          href: "/owner/promotions/list/view/" + this.promotion_id,
        },
        {
          text: "Delete",
          disabled: true,
          href: "/owner/promotions/list/view/" + this.promotion_id + "/delete",
        },
      ],
      navbar_cols: 3,
    });
    this.load_promotion();

    var options = {
      offset: 50,
      duration: 1000,
      easing: "easeInOutCubic",
    };
    this.$vuetify.goTo("#owner_delete_promotion_section", options);
  },
};
</script>